import { useMantineTheme } from '@mantine/core';

import { useMediaQuery } from './useMediaQuery';

export const useIsLgBreakpoint = () => {
  const mantineTheme = useMantineTheme();

  return useMediaQuery(`(min-width: ${mantineTheme.breakpoints.lg}px)`);
};
